module.exports = __webpack_public_path__ + "img/cake-23.27be00e0.svg";